import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Business, getFullAddress, License } from 'src/model/business';
import { Customer } from 'src/model/customer.model';
import { FormJ } from 'src/model/formJ.model';

@Component({
    selector: 'app-payment-voucher',
    templateUrl: './payment-voucher.component.html',
    styleUrls: ['./payment-voucher.component.scss'],
    standalone: false
})
export class PaymentVoucherComponent implements OnInit {
  protected sharedService = inject(SharedService);

  @Input() selectedFormJ: FormJ;
  @Input() selectedCustomer: Customer;
  @Input() selectedBusiness: Business;
  @Input() selectedBusinessLicense: License;
  fullAddress = computed<string>(() => getFullAddress(this.selectedBusinessLicense.Address));

  ngOnInit(): void {
  }

}
